export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9715.0a59f5ad.jpg";